import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { LinkButton } from '../components/form';
import { HeroImage } from '../components/HeroImage';
import { Sponsors, TitleSponsors } from '../components/Sponsors';
import { PrimaryFont, TaglineFont } from '../components/styles';
import { Tracks } from '../components/Tracks';
import { useIsMobile } from '../hooks/responsive';
import { EXTERNAL_LINKS } from '../utils/links';

const ContentContainer = styled.div<{ isMobile: boolean }>`
  box-sizing: border-box;
  margin: 0 auto ${({ isMobile }) => (isMobile ? 350 : 200)}px;
  padding: 0 50px;
  max-width: 1000px;
`;

const DateContainer = styled.div`
  margin-top: -15px;
  margin-bottom: 150px;
  z-index: 5;
`;

export const TagLine = styled(TaglineFont)`
  display: block;
  margin-bottom: 30px;
  font-size: 40px;
`;

const OverviewText = styled(PrimaryFont)`
  display: block;
  max-width: 900px;
  margin-bottom: 35px;
  line-height: 22px;
  letter-spacing: 0.5px;
`;

const TracksContainer = styled.div`
  margin-top: 125px;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
`;

const SponsorsContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-top: 75px;
  margin-bottom: 250px;
`;

declare global {
  interface Window {
    loadImage: () => void;
  }
}

const PageHomeBase: React.FC<RouteComponentProps> = props => {
  useEffect(() => {
    window.loadImage();
  }, []);

  const { isMobile } = useIsMobile();

  return (
    <ContentContainer isMobile={isMobile}>
      <HeroImage />

      <DateContainer>
        <OverviewText bold style={{ marginBottom: 0 }}>
          DubHacks '21
        </OverviewText>
        <OverviewText>Oct 23-24, 2021 | Virtual</OverviewText>
      </DateContainer>

      <TagLine>Reconnecting, piece by piece</TagLine>
      <OverviewText>
        Whether we've been exploring and creating from our rooms at home, on the way to work, or in our campus dorms,
        we've each found our own individual spaces during this pandemic. Let's reconnect, piece by piece.
      </OverviewText>
      <OverviewText>
        At DubHacks '21, attendees bring their individual spaces and ideas together while reconnecting with old friends
        and meeting online ones for the first time. Our tracks, mentors, sponsors, and hackers are pieces to the puzzle
        that make up the DubHacks community. We hope to empower our students to build impactful tech solutions, foster a
        community for learning and experimentation, and seek to advance diversity and equity in the tech industry.
      </OverviewText>
      <OverviewText bold>To keep our puzzle pieces safe, this year's hackathon will be virtual &lt;3</OverviewText>
      <OverviewText>Claim your piece of the puzzle!</OverviewText>
      <LinkButton href={EXTERNAL_LINKS.APPLY_FORM} target="_blank" rel="noopener noreferrer">
        Apply!
      </LinkButton>

      <TracksContainer>
        <TagLine>Tracks for the fall</TagLine>
        <Tracks />
      </TracksContainer>

      <SponsorsContainer>
        <TagLine>Title Sponsors</TagLine>
        <TitleSponsors />
        <TagLine>Sponsors</TagLine>
        <Sponsors />
      </SponsorsContainer>
    </ContentContainer>
  );
};

export const PageHome = withRouter(PageHomeBase);
